import { get } from "svelte/store";

import stsRequest from "commerce/lib/sts-request";

import { customExchange, waiting }      from "stores/toggles";
import { customQuotes, standardQuotes } from "stores/quotes";

export function loadQuotes() {
    const quotes = get(customExchange) ? customQuotes : standardQuotes;

    waiting.set(true);

    return Promise.all(
        Object.values(get(quotes))
            .flat()
            .map(quote =>
                stsRequest({
                    protocol : "Game.gw2.Exchange",
                    command  : "GetInverseQuote",
                    body     : {
                        Type     : quote.command,
                        Quantity : quote.quantity
                    }
                })
                .then((res) => {
                    // NOTE: "quantity" here is the Exchange protocol being weird --
                    // we've asked it how much Quantity of Type costs, and it's returning
                    // the resulting price in a field named "quantity".
                    // "tooExpensive" means they don't have enough to buy this package. (it disables the buy button)
                    const price        = res.quantity;
                    const tooExpensive = price > window.native.stats[quote.notType];

                    const updated = {
                        price,
                        coins_per_gem : res.coins_per_gem,
                        updating      : false,
                        tooExpensive
                    };

                    quotes.updateQuote(quote.what2what, updated, quote.idx);
                })
            )
    )
    .catch(err => {
        console.log("failed loading quotes");
        // todo: proper error handling?
        // pop the error modal
    })
    .finally(() => {
        waiting.set(false);
    });
}
